/** Approved elevation effects. Ordinary surfaces use neutral borders instead. */
export const SHADOW_TOKENS = Object.freeze({
  shadow_floating:
    "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)",
  shadow_overlay:
    "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
});
